module.exports = __webpack_public_path__ + "img/total-users-icon.8a55eeb8.svg";